export default {
  forgot_password_submit: {
    title: 'Đặt lại mật khẩu',
    submit_complete: 'Đã gửi thành công',
    password_reset: 'Đã đặt lại mật khẩu',
  },
}
